<!-- 用于测量 itemHeight 的隐藏探针，仅在初始化前且有数据时渲染，与 visibleItems 完全解耦 -->
<div #templateContainer *ngIf="!initialized && ncItems.length > 0"
    style="visibility:hidden;position:absolute;pointer-events:none;">
    <ng-container [ngTemplateOutlet]="ncItemTemplate"
        [ngTemplateOutletContext]="{$implicit: ncItems[0], index: 0}"></ng-container>
</div>

<div class="viewport" #viewport (scroll)="onScroll()">
    <div class="total-padding" [style.height.px]="totalPadding">
        <div class="item-container" [style.transform]="'translateY(' + topPadding + 'px)'">
            <div *ngFor="let item of visibleItems; trackBy: trackByIndex">
                <ng-container [ngTemplateOutlet]="ncItemTemplate"
                    [ngTemplateOutletContext]="{$implicit: item.data, index: item.index}"></ng-container>
            </div>
        </div>
    </div>
</div>